import type { TileImage, Variation } from '@shared/types/types.ts';

const EMPTY_IMAGE: TileImage = { id: '', alt: '', fallback: '', jpeg: '', webp: '' };

export function getStatusQuoImages(rawImages: TileImage[]): { images: TileImage[]; primaryImage: TileImage } {
    const images = rawImages.slice(0, 3);
    const first = images[0];
    return { images, primaryImage: first !== undefined ? first : EMPTY_IMAGE };
}

export function getLayoutImages(variation: Variation): { images: TileImage[]; primaryImage: TileImage } {
    return getStatusQuoImages(variation.images);
}
